import { useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { useAuth0 } from "@dhn/components/contexts/react-auth0-spa";
import { GET_PHARMACY_PROVIDER_LOGO } from "../../queries";

// Imagen para la vista previa del logo del consultorio. El archivo recién elegido
// se lee en el navegador; el logo guardado vive en `pharmacy_provider_logo` y se
// descarga con el token del usuario (igual que el logo del navbar).
export default function useLogoPreview(fileLogo, pharmacyProviderId) {
  const { getTokenSilently } = useAuth0();
  const [selectedSource, setSelectedSource] = useState("");
  const [savedSource, setSavedSource] = useState("");
  const isNewFile = fileLogo instanceof Blob;

  const { data: { byMedicalStaffProviderpharmacyProviderLogo } = {} } = useQuery(
    GET_PHARMACY_PROVIDER_LOGO,
    {
      skip: !pharmacyProviderId,
      fetchPolicy: "cache-and-network",
      variables: { where: { pharmacyProviderId: Number(pharmacyProviderId) } },
    },
  );
  const savedLogos = byMedicalStaffProviderpharmacyProviderLogo?.pharmacyProviderLogo || [];
  const savedFile = savedLogos[savedLogos.length - 1] || null;
  const savedFileName = savedFile?.name || "";

  useEffect(() => {
    if (!isNewFile) {
      setSelectedSource("");
      return undefined;
    }
    const reader = new FileReader();
    reader.onload = ({ target }) => setSelectedSource(target?.result || "");
    reader.readAsDataURL(fileLogo);
    return undefined;
  }, [fileLogo, isNewFile]);

  useEffect(() => {
    if (!savedFileName) {
      setSavedSource("");
      return undefined;
    }

    let objectUrl = "";
    let isActive = true;
    (async () => {
      try {
        const accessToken = await getTokenSilently();
        const response = await fetch(
          `${process.env.REACT_APP_APOLLO_CLIENT_URI}/claim-files/${savedFileName}`,
          {
            body: JSON.stringify(savedFile),
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${accessToken}`,
            },
          },
        );
        if (!response.ok || !isActive) return;
        objectUrl = URL.createObjectURL(await response.blob());
        setSavedSource(objectUrl);
      } catch (error) {
        console.error("No se pudo cargar el logo del consultorio:", error);
      }
    })();

    return () => {
      isActive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [savedFileName]);

  return {
    source: isNewFile ? selectedSource : savedSource,
    label: isNewFile ? fileLogo.name : savedFileName,
  };
}
